"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperMethods = void 0;
const tslib_1 = require("tslib");
/**
 * @author darrmill@microsoft.com, yefuwang@microsoft.com
 */
const axios_1 = tslib_1.__importDefault(require("axios"));
const fs_1 = tslib_1.__importDefault(require("fs"));
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const path = tslib_1.__importStar(require("path"));
const unzip = tslib_1.__importStar(require("unzipper"));
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const ManifestUtils_1 = require("../../driver/teamsApp/utils/ManifestUtils");
const zipFile = "project.zip";
class HelperMethods {
    static async downloadProjectTemplateZipFile(projectFolder, projectRepo, projectBranch) {
        const projectTemplateZipFile = `${projectRepo}/archive/${projectBranch || ""}.zip`;
        return axios_1.default
            .get(projectTemplateZipFile, {
            responseType: "stream",
        })
            .then((response) => {
            return new Promise((resolve, reject) => {
                response.data
                    .pipe(fs_1.default.createWriteStream(`${projectFolder}/${zipFile}`))
                    .on("error", function (err) {
                    reject(
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    `Unable to download project zip file for "${projectTemplateZipFile}".\n${err}`);
                })
                    .on("close", async () => {
                    await HelperMethods.unzipProjectTemplate(projectFolder);
                    resolve();
                });
            });
        })
            .catch((err) => {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            console.log(`Unable to download project zip file for "${projectTemplateZipFile}".\n${err}`);
        });
    }
    static async unzipProjectTemplate(projectFolder) {
        return new Promise((resolve, reject) => {
            // TODO: Verify file exists
            const readStream = fs_1.default.createReadStream(`${projectFolder}/${zipFile}`);
            readStream
                .pipe(unzip.Extract({ path: projectFolder }))
                .on("error", function (err) {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                reject(`Unable to unzip project zip file for "${projectFolder}".\n${err}`);
            })
                .on("close", () => {
                HelperMethods.moveUnzippedFiles(projectFolder);
                resolve();
            });
        });
    }
    static moveUnzippedFiles(projectFolder) {
        // delete original zip file
        const zipFilePath = path.resolve(`${projectFolder}/${zipFile}`);
        if (fs_1.default.existsSync(zipFilePath)) {
            fs_1.default.unlinkSync(zipFilePath);
        }
        // get path to unzipped folder
        const unzippedFolder = fs_1.default.readdirSync(projectFolder).filter(function (file) {
            return fs_1.default.statSync(`${projectFolder}/${file}`).isDirectory();
        });
        // construct paths to move files out of unzipped folder into project root folder
        const fromFolder = path.resolve(`${projectFolder}/${unzippedFolder[0]}`);
        HelperMethods.copyAddinFiles(fromFolder, projectFolder);
        // delete project zipped folder
        fs_1.default.rmSync(fromFolder, { recursive: true, force: true });
    }
    static copyAddinFiles(fromFolder, toFolder) {
        fs_extra_1.default.copySync(fromFolder, toFolder, {
            filter: (path) => !path.includes("node_modules"),
        });
    }
    static async updateManifest(projectRoot, addinManifestPath) {
        // Read add-in manifest file
        const addinManifest = await teamsfx_api_1.ManifestUtil.loadFromPath(addinManifestPath);
        // Open project manifest file
        const manifestTemplatePath = ManifestUtils_1.manifestUtils.getTeamsAppManifestPath(projectRoot);
        if (!(await fs_extra_1.default.pathExists(manifestTemplatePath))) {
            return;
        }
        const manifest = await teamsfx_api_1.ManifestUtil.loadFromPath(manifestTemplatePath);
        // Update project manifest
        manifest.extensions = addinManifest.extensions;
        manifest.authorization = addinManifest.authorization;
        // Save project manifest
        await teamsfx_api_1.ManifestUtil.writeToPath(manifestTemplatePath, manifest);
    }
    // Move the manifest.json and assets to appPackage folder and update related files.
    static async moveManifestLocation(projectRoot, manifestRelativePath) {
        const manifestPath = path.join(projectRoot, manifestRelativePath);
        if (await fs_extra_1.default.pathExists(manifestPath)) {
            if (!(await fs_extra_1.default.pathExists(path.join(projectRoot, "appPackage")))) {
                await fs_extra_1.default.mkdir(path.join(projectRoot, "appPackage"));
            }
            await fs_extra_1.default.rename(manifestPath, path.join(projectRoot, "appPackage", "manifest.json"));
            const packageJsonPath = path.join(projectRoot, "package.json");
            if (await fs_extra_1.default.pathExists(packageJsonPath)) {
                const content = (await fs_extra_1.default.readFile(packageJsonPath)).toString();
                const reg = /\smanifest\.json\"/g;
                const data = content.replace(reg, ` appPackage/manifest.json"`);
                await fs_extra_1.default.writeFile(packageJsonPath, data);
            }
            const assetsPath = path.join(projectRoot, "assets");
            if (await fs_extra_1.default.pathExists(assetsPath)) {
                await fs_extra_1.default.move(assetsPath, path.join(projectRoot, "appPackage", "assets"));
            }
            const webpackConfigPath = path.join(projectRoot, "webpack.config.js");
            if (await fs_extra_1.default.pathExists(webpackConfigPath)) {
                const content = (await fs_extra_1.default.readFile(webpackConfigPath)).toString();
                const manifestReg = /\"manifest\*\.json\"/g;
                const assetsReg = /\"assets\/\*\"/g;
                const data = content
                    .replace(manifestReg, `"appPackage/manifest*.json"`)
                    .replace(assetsReg, `"appPackage/assets/*"`);
                await fs_extra_1.default.writeFile(webpackConfigPath, data);
            }
            const htmlPath = path.join(projectRoot, "src", "taskpane", "taskpane.html");
            if (await fs_extra_1.default.pathExists(htmlPath)) {
                const content = (await fs_extra_1.default.readFile(htmlPath)).toString();
                const assetsReg = /\/assets\//g;
                const data = content.replace(assetsReg, `/appPackage/assets/`);
                await fs_extra_1.default.writeFile(htmlPath, data);
            }
        }
    }
}
exports.HelperMethods = HelperMethods;
//# sourceMappingURL=helperMethods.js.map